// ธงภาษาปัจจุบัน (หน้าตาเหมือนของเดิมในเมนู hamburger ตรง "Language / ภาษา")
// กดที่ธง -> มีหน้าต่างเด้งขึ้นมาให้เลือก 8 ภาษา
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { LANGS, getLang, setLang, subscribeLang } from './index';
import './langswitcher.css';

export default function LangFlags() {
  const [lang, setL] = useState(getLang());
  const [open, setOpen] = useState(false);
  useEffect(() => subscribeLang(setL), []);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];

  const picker = open ? ReactDOM.createPortal(
    <div className="bt-langpick-backdrop" data-no-i18n="" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
      <div className="bt-langpick" role="dialog" aria-label="Language">
        <div className="bt-langpick-head">
          <span>Language / ภาษา</span>
          <button type="button" className="bt-langpick-close" aria-label="close" onClick={() => setOpen(false)}>×</button>
        </div>
        <div className="bt-langpick-list">
          {LANGS.map((l) => (
            <button key={l.code} type="button" className={'bt-langpick-item' + (l.code === lang ? ' active' : '')}
              onClick={() => { setLang(l.code); setOpen(false); }}>
              <img src={l.flag} alt="" />
              <span>{l.label}</span>
              {l.code === lang ? <span className="bt-langpick-check">✓</span> : null}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <ul className="logo-list-footer" data-no-i18n="">
        <li role="button" title={cur.label} onClick={() => setOpen(true)}>
          <img className="lang-img active-lang bt-lang-cur" src={cur.flag} alt={cur.label} />
        </li>
      </ul>
      {picker}
    </>
  );
}
